<template>
  <div class="page-wrapper" >
    <breadcrumb :items="breadcrumbItems" />
    <div class="overview-wrap">
      <div class="title-wrap billing-overview-header gap-3">
        <h5 class="mb-0 me-auto">Billing Overview</h5>
        <div class="d-flex align-items-center location-filter gap-2">
            <label for="locationFilter" >
              View by Location:
            </label>
            <multiselect
              id="locationFilter"
              v-model="selectedLocation"
              :options="locationOptions"
              :searchable="false"
              :show-labels="false"
              placeholder="All Locations"
              class="form-select-custom"
              :allow-empty="false"
              :close-on-select="true"
              :max-height="250"
              label="label"
              track-by="value"
            />
        </div>
        <div class="filter-wrap">
          <div class="me-2">Filter:</div>
          <div class="filter-date">
            <date-picker
              input-class="memberSearch-field"
              placeholder="Enter Date"
              type="month"
              value-type="format"
              v-model="selectedYM"
              :min="minYM"
              format="MM/YYYY"
            ></date-picker>
          </div>
        </div>
      </div>
      <div class="bill-card-bg text-center mt-3" v-if="Object.keys(billingOverview).length === 0">
        No data found for this month
      </div>
       <div v-else>
           <div class="mt-3 billingoverview_table-lg">
        <div class="billingoverview_table d-grid" :class="responsiveGridClass">
          <div v-for="(column, colIndex) in chunkedBillingOverview" :key="colIndex" class="billingoverview_column">
            <div class="billingoverview_header">
              <ul v-if="column.length" class="p-0 m-0">
                <li class="d-flex ">
                  <span class="header-title flex-grow-1 p-2">Failed Reason</span>
                  <span class="header-value p-2">Count</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <ul class="billingoverview_body m-0 p-0 d-grid" :class="responsiveGridClass">
          <li v-for="(item, index) in billingOverview" :key="index" class="d-flex billingoverview_list">
            <span class="titlevalue flex-grow-1 p-2">{{ item.title }}</span>
            <span class="countvalue p-2">{{ item.count }}</span>
          </li>
        </ul>
      </div>
      <div class="billingoverview_table-sm">
        <div class="mt-3 bill-card-bg table-responsive p-0 br-0 mb-0">
        <table class="table">
          <thead>
            <th>Failed Reason</th>
             <th>Count</th>
          </thead>
          <tbody>
            <tr  v-for="(item, index) in billingOverview" :key="index">
              <td>{{ item.title }}</td>
              <td>{{item.count }}</td>
            </tr>
          </tbody>
        </table>
        </div>
       
      </div>
       </div>
      

      <!-- payment overview -->
      <div class="row h-100">
        <div class="col-xl-4 col-lg-12 col-md-12 mt-4">
          <h5>Payment Overview</h5>
          <div class="bill-card-bg">
            <div class="donut-chart-wrap">
              <DonutChart :series="seriesData" />
              <div class="w-fit">
                <h5 class="mb-0 me-2 count-num">{{paymentOverview.totalCount}}</h5>
                <p class="mb-0">Total Processed</p>
                <div class="d-flex align-items-center mt-3">
                  <div class="d-flex align-items-center">
                    <div class="success me-2"></div>
                    <div class="me-1">Total Success :</div>
                  </div>
                  <div class="">{{paymentOverview.successCount}}</div>
                </div>
                <div class="d-flex align-items-center mt-1">
                  <div class="failure me-2"></div>
                  <div><span class="me-1">Total Failure : </span></div>
                  <div class="">{{paymentOverview.failedCount}}</div>
                </div>
                <div class="d-flex align-items-center mt-1">
                  <div class="dispute me-2"></div>
                  <div><span class="me-1">Total Dispute : </span></div>
                  <div class="">{{paymentOverview.disputeCount}}</div>
                </div>
                <div class="d-flex mt-4 gap-4 flex-wrap">
                <div class="">
                  <h4 class="mb-0">${{paymentOverview.successAmount}}</h4>
                  Total Success Amount
                </div>
                <div class="">
                  <h4 class="mb-0">${{paymentOverview.failedAmount}}</h4>
                  Total Failed Amount
                </div>
                <div class="">
                  <h4 class="mb-0">${{paymentOverview.disputeAmount}}</h4>
                  Total Dispute Amount
                </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-8 col-lg-12 col-md-12 mt-4">
          <h5 class="mg-5">Payment Status</h5>
          <div class="bill-card-bg">
            <div class="d-flex justify-content-between flex-wrap gap-2">
              <div class="total">
              <template v-if="graphData.totalAmount">
                <div class="total-txt">Total :</div>
                <h3 class="mb-0 ms-2">${{graphData.totalAmount}}</h3>
                </template>
              </div>
              <!--<div class="index-wrap gap-3 flex-wrap">
                <div class="d-flex gap-2 align-items-center">
                  <div class="dot-index"></div>
                  <div>Posted</div>
                </div>
                <div class="d-flex gap-2 align-items-center">
                  <div class="dot-index paid"></div>
                  <div>Paid</div>
                </div>
                <div class="d-flex gap-2 align-items-center">
                  <div class="dot-index failed"></div>
                  <div>Failed</div>
                </div>
                <div class="d-flex gap-2 align-items-center">
                  <div class="dot-index unprocessed"></div>
                  <div>Processing</div>
                </div>
                <div class="d-flex gap-2 align-items-center">
                  <div class="dot-index dispute"></div>
                  <div>Dispute</div>
                </div>
              </div>-->
            </div>
            <MultipleBarChart :graph-data="graphData" />
          </div>
        </div>
      </div>
    </div>
    <div class="title-wrap pt-4">
      <h5 class="mb-0">Billing Information</h5>
      <div class="filter-wrap gap-3">
        <!-- <div class="me-2">Filter Via:</div> -->
        <!-- <div class="filter-date">
          <select name="" id="" class="form-select shadow-none">
            <option value="">Member Only</option>
            <option value="">Member + Spouse</option>
            <option value="">Member + Child(ren)</option>
            <option value="">Family (Member+ Spouse+ 8 children)</option>
          </select>
        </div>
        <div class="filter-date">
          <date-picker
            input-class="memberSearch-field"
            placeholder="Enter Date"
            type="date"
            value-type="format"
          ></date-picker>
        </div> -->
        <div class="filter-btn" v-b-toggle.collapseExample>
          <img src="../../../assets/images/bar-filter.svg" />
          Filter
        </div>
      </div>
    </div>
    <!-- Filter Collapse -->
    <b-collapse id="collapseExample" class="mt-3">
      <div class="card card-body bill-card-bg p-4">
        <form @submit.prevent="applyFilter">
          <h6>Filter Data</h6>
          <div class="row paymentSearch-wrap">
            <div class="col-md-6 col-lg-4 col-xl-3 mb-3">
              <label for="policy_id" class="mb-1 w-100">Policy ID</label>
              <input
                  type="number"
                  v-model="filterQuery.policy_id"
                  class="memberSearch-field"
                  placeholder="Enter Policy ID"
              />
            </div>
            <div class="col-md-6 col-lg-4 col-xl-3 mb-3">
              <label for="" class="mb-1 w-100">First Name</label>
              <input
                  type="text"
                  v-model="filterQuery.firstname"
                  class="memberSearch-field"
                  placeholder="Enter First Name"
              />
            </div>
            <div class="col-md-6 col-lg-4 col-xl-3 mb-3">
              <label for="" class="mb-1 w-100">Last Name</label>
              <input
                  type="text"
                  v-model="filterQuery.lastname"
                  class="memberSearch-field"
                  placeholder="Enter Last Name"
              />
            </div>
            <div class="col-md-6 col-lg-4 col-xl-3 mb-3">
              <label for="" class="mb-1 w-100">Email</label>
              <input
                  type="email"
                  v-model="filterQuery.email"
                  class="memberSearch-field"
                  placeholder="Enter Email"
              />
            </div>
            <div class="col-md-6 col-lg-4 col-xl-3 mb-3">
              <label for="" class="mb-1 w-100">Card Number</label>
              <input
                  type="text"
                  v-model="filterQuery.card_no"
                  class="memberSearch-field"
                  placeholder="Enter Card Number"
              />
            </div>
            <!-- <div class="col-md-6 col-lg-4 col-xl-3 mb-3">
              <label for="" class="mb-1 w-100">Plan Name</label>
              <select v-model="filterQuery.plan" class="form-select shadow-none">
                <option value="">All</option>
                <option value="">First Plan</option>
                <option value="">Second Plan</option>
              </select>
            </div>
            <div class="col-md-6 col-lg-4 col-xl-3 mb-3">
              <label for="" class="mb-1 w-100">Plan Price</label>
              <input
                  type="number"
                  v-model="filterQuery.plan_price"
                  class="memberSearch-field"
                  placeholder="Enter Plan Price"
              />
            </div>
            <div class="col-md-6 col-lg-4 col-xl-3 mb-3">
              <label for="" class="mb-1 w-100">Tier</label>
              <select v-model="filterQuery.tier" class="form-select shadow-none">
                <option value="">All</option>
                <option value="IO">IO</option>
                <option value="IS">IS</option>
                <option value="IC">IC</option>
                <option value="IF">IF</option>
              </select>
            </div>

            <div class="col-md-2 col-lg-2 col-xl-2 mb-3">
              <label for="" class="mb-1 w-100">Invoice</label>
              <select v-model="filterQuery.invoice" class="form-select shadow-none" placeholder="Select Invoice">
                <option value="">All</option>
                <option value="initial">Initial</option>
                <option value="recurring">Recurring</option>
              </select>
            </div>
            -->
            <div class="col-md-6 col-lg-4 col-xl-3 mb-3">
              <label for="" class="mb-1 w-100">Transaction Status</label>
              <select v-model="filterQuery.transaction_status" class="form-select shadow-none" placeholder="Select Status">
                <option value="">All</option>
                <option value="paid">Paid</option>
                <option value="posted">Posted</option>
                <option value="unpaid">Unpaid</option>
                <option value="processing">Processing</option>
                <option value="dispute">Dispute</option>
                <option value="failed">Failed</option>
              </select>
            </div>

            <!-- <div class="col-md-6 col-lg-4 col-xl-3 mb-3">
              <label for="" class="mb-1 w-100">Card Number</label>
              <input
                  type="text"
                  v-model="filterQuery.card_no"
                  class="memberSearch-field"
                  placeholder="Enter Card Number"
              />
            </div> -->
            <div class="col-md-6 col-lg-4 col-xl-3 mb-3">
              <label for="" class="mb-1 w-100">Processed Date</label>
              <div class="filter-date">
                <date-picker
                    input-class="memberSearch-field"
                    class="transaction_date"
                    placeholder="Select Processed Date"
                    type="date"
                    v-model="filterQuery.processed_date"
                    value-type="format"
                ></date-picker>
              </div>
            </div>
            <div class="col-md-6 col-lg-4 col-xl-3 mb-3">
              <label for="" class="mb-1 w-100">Rep/ User Name</label>
              <input
                  type="tel"
                  v-model="filterQuery.rep_user_name"
                  class="memberSearch-field"
                  placeholder="Enter Rep/ User Name"
              />
            </div>
            <div class="col-md-6 col-lg-4 col-xl-3 mb-3">
              <label for="" class="mb-1 w-100">Phone Number</label>
              <input
                  type="tel"
                  v-model="filterQuery.phone_number"
                  class="memberSearch-field"
                  placeholder="Enter Phone Number"
              />
            </div>
            <div class="col-md-6 col-lg-4 col-xl-3 mb-3">
              <label for="" class="mb-1 w-100">Card Type</label>
              <select v-model="filterQuery.card_type" class="form-select shadow-none" placeholder="Select Card Type">
                <option value="">All</option>
                <option value="visa">Visa Card</option>
                <option value="mastercard">Master Card</option>
                <option value="discover">Discover</option>
              </select>
            </div>
            <!--Failed Reason-->
            <div class="col-md-6 col-lg-4 col-xl-3 mb-3 failedreason-select">
               <multi-selectable-input
                :key="clearKey"
                :vmodel="filterQuery.reason"
                @update:vmodel="filterQuery.reason = $event"
                 labelName="Failed Reason"
                 :options="failedReasons"
                 placeholder="Select Failed Reason(s)"
                :activeData.sync="failedReasons"
                 :multiple="true"  
                 trackBy="value"
                 displayLabel="text"
                 :optionsLimit="25"
              />  
            </div>
            
            <!-- <div class="col-md-6 col-lg-4 col-xl-3 mb-3">
              <label for="" class="mb-1 w-100">Retry Date</label>
              <div class="filter-date">
                <date-picker
                    input-class="memberSearch-field"
                    class="transaction_date"
                    placeholder="Select retry Date"
                    type="date"
                    v-model="filterQuery.retry_date"
                    value-type="format"
                ></date-picker>
              </div>
            </div> -->
          </div>
          <div class="row justify-content-md-end flex-wrap">
            <div class="col-12 col-sm-6 col-md-auto">
              <button type="button" class="clear-search w-100 w-md-auto" @click="clearData">
                Clear Search
              </button>
            </div>
            <div class="col-12 col-sm-6 col-md-auto">
              <button type="submit" class="univ-btn w-100 w-md-auto">
                Search
              </button>
            </div>
            <div class="col-12 col-sm-6 col-md-auto">
              <button type="button" class="univ-btn w-100 w-md-auto export-button" @click="exportMember">
                <i class="fas fa-file-export export-icon"></i> Export
              </button>
            </div>
          </div>
        </form>
      </div>
    </b-collapse>
    <!-- Filtered Data Table -->
    <div class="mt-3 bill-card-bg">
      <div class="top-pagination">
        <pagination :rows.sync="paymentList" :filters="filterQuery" />
      </div>
      <div class="table-responsive">
  <table class="table ">
        <thead>
          <th>System Id</th>
          <th>Member Details</th>
          <th>Plan Details</th>
          <th>Invoice</th>
          <th>Billing Month</th>
          <!-- <th>Tier</th> -->
          <th>Card Type</th>
          <th>Transaction Status</th>
          <th>Transaction Date</th>
          <th>Failed Reason</th>
          <th>Rep Name</th>
          <th>Actions</th>
        </thead>
        <tbody>
          <!-- Skeleton rows while loading -->
          <template v-if="isBillingLoading">
            <tr v-for="n in 8" :key="'skel-' + n" class="skeleton-row">
              <td><span class="skeleton skeleton-cell"></span></td>
              <td>
                <span class="skeleton skeleton-cell mb-1 d-block"></span>
                <span class="skeleton skeleton-cell mb-1 d-block"></span>
                <span class="skeleton skeleton-cell mb-1 d-block"></span>
                <span class="skeleton skeleton-cell d-block"></span>
              </td>
              <td>
                <span class="skeleton skeleton-cell mb-1 d-block"></span>
                <span class="skeleton skeleton-cell mb-1 d-block"></span>
                <span class="skeleton skeleton-cell d-block"></span>
              </td>
              <td><span class="skeleton skeleton-cell"></span></td>
              <td><span class="skeleton skeleton-cell"></span></td>
              <td>
                <span class="skeleton skeleton-cell mb-1 d-block"></span>
                <span class="skeleton skeleton-cell mb-1 d-block"></span>
                <span class="skeleton skeleton-cell d-block"></span>
              </td>
              <td><span class="skeleton skeleton-pill"></span></td>
              <td>
                <span class="skeleton skeleton-cell mb-1 d-block"></span>
                <span class="skeleton skeleton-cell d-block"></span>
              </td>
              <td><span class="skeleton skeleton-cell"></span></td>
              <td><span class="skeleton skeleton-cell"></span></td>
              <td><span class="skeleton skeleton-action"></span></td>
            </tr>
          </template>

          <template v-else>
            <tr>
              <td v-if="!paymentLength" colspan="11" align="center">
                No records found.
              </td>
            </tr>

            <tr
              :key="index"
              v-for="(item, index) in paymentList.data"
              :id="item.status"
            >
              <td>{{ item.invoice_policy_id ?? "N/A" }}</td>
              <td>
                <ul>
                  <li>
                    Full Name: {{ item.firstname }} {{ item.middlename }}
                    {{ item.lastname }}
                  </li>
                  <li>Email: {{ item.email ?? "N/A" }}</li>
                  <li>Phone Number: {{ item.phone_number ?? "N/A" }}</li>
                  <li>
                    Address: {{ item.state_name }}, {{ item.city_name }},
                    {{ item.postal_code }}
                  </li>
                  <li>Payer ID: {{ item.payer_id ?? "N/A" }}</li>
                </ul>
              </td>
              <td v-if="item.plans.length > 0">
                <ul v-for="(plan, index) in item.plans" :key="index">
                  <li>{{ plan.plan_name ?? "N/A" }}</li>
                  <li>Price: ${{ plan.plan_price ?? "N/A" }}</li>
                  <li>Tier: {{ plan.tier ?? "N/A" }}</li>
                </ul>
              </td>
              <td v-else>N/A</td>
              <td>{{ item.invoice_status ?? "N/A" }}</td>
              <td>{{ item.invoice_billing_month ?? "N/A" }}</td>
              <td>
                <ul>
                  <li>Name: {{ item.card_name ?? "N/A" }}</li>
                  <li>Card Type: {{ item.card_type ?? "N/A" }}</li>
                  <li>
                    Card Number: #### #### #### {{ item.card_detail ?? "N/A" }}
                  </li>
                  <li>
                    Card Expiration: {{ item.card_expiration_full_date ?? "N/A" }}
                  </li>
                  <li>Card CVC: {{ item.card_cvc ?? "N/A" }}</li>
                </ul>
              </td>
              <td>
                <div
                  :class="{
                    'success-pill': item.transaction_status === 'posted',
                    'failure-pill': item.transaction_status === 'failed',
                    null:
                      item.transaction_status !== 'success' &&
                      item.transaction_status !== 'failure'
                  }"
                  class="status-pill uppercase-status"
                >
                  {{ item.transaction_status ?? "N/A" }}
                </div>
              </td>

              <td>
                <ul>
                  <li>Processed : {{ item.transaction_date ?? "N/A" }}</li>
                  <li>Retry : {{ item.retry_transaction_date ?? "N/A" }}</li>
                </ul>
              </td>
              <td class="failed_reason">{{ item.failed_reason || "" }}</td>
              <td>{{ item.agent_full_name ?? "N/A" }}</td>
              <td>
                <div class="action-icons" v-if="item.invoice_policy_id">
                  <custom-route-button
                    title="View Details"
                    iconClass="fas fa-info"
                    :routeLink="{
                      name: 'MemberPolicyDetail',
                      params: { policyId: encodedId(item.invoice_policy_id) }
                    }"
                  />
                </div>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
      </div>
      <pagination :rows.sync="paymentList" :filters="filterQuery" />
    </div>
  </div>
</template>

<script>
import Breadcrumb from "@/components/ui/Breadcrumb.vue";
import axios from "axios";
import Helper from "@/resource/Helper";
import DonutChart from "./DonutChart.vue";
import MultipleBarChart from "./MultipleBarChart.vue";
import Pagination from "./BillingPagination.vue";
import Api from "@/resource/Api";

const randomIcons = [
  "fas fa-user-tie",
  "fas fa-magnifying-glass-dollar",
  "fas fa-check",
  "fas fa-info",
  "fas fa-exclamation",
  "fas fa-times",
  "fas fa-user-check",
  "fas fa-user-slash",
  "fas fa-user-tie",
  "fas fa-times",
  "fas fa-check",
  "fas fa-info",
  "fas fa-exclamation",
  "fas fa-ellipsis-v",
  "fas fa-user-check",
  "fas fa-user-slash",
];

const filterData = {
  firstname: "",
  lastname: "",
  policy_id: "",
  // card_no:'',
  email: "",
  phone_number: "",
  // plan_name: "",
  // plan_price: "",
  // invoice: "",
  // tier: "",
  card_no: "",
  card_type: "",
  rep_user_name: "",
  transaction_status: "",
  processed_date: "",
  // retry_date: "",
  exportPageSize: "",
  reason: [],
};

export default {
  name: "Billing",
  components: {
    Breadcrumb,
    Pagination,
    DonutChart,
    MultipleBarChart
  },
  data() {
    return {
      windowWidth: window.innerWidth,
      locationOptions: [
        { label: 'All Locations', value: null },
        { label: 'WPB SALES', value: '103985' },
        { label: 'HMS SALES', value: '103981' },
        { label: 'PLANT SALES', value: '103979' },
        { label: 'REMOTE SALES', value: '103982' },
        { label: 'CUSTO SALES', value: '103978' },
      ],
      selectedLocation: { label: 'All Locations', value: null },
      locationAgentId: null,
      filterQuery: { ...filterData },
      paymentList: [],
      pagination: { page: 1 },
      clear: false,
      clearKey: 0,
      breadcrumbItems: [{ title: "Billing", active: true }],
      selectedYM: `${new Date().getMonth() + 1}`.padStart(2, '0') + '/' + `${new Date().getFullYear()}`,
      graphData: {},
      billingOverview: {},
      paymentOverview: {
        successCount: 0,
        failedCount: 0,
        successAmount: 0,
        failedAmount: 0,
        disputeCount:0,
        disputeAmount:0
      },
      randomIcons,
      isBillingLoading: false,
    };
  },
  computed: {
    columnCount() {
      const length = this.billingOverview.length;
      if (this.windowWidth < 567) return 1;
      else if (this.windowWidth < 768) return 2;
      else if (this.windowWidth < 992) return 3;
      else return length > 4 ? 4 : 4;
    },
    chunkedBillingOverview() {
      const length = this.billingOverview.length;
      const columnCount = this.columnCount;
      if (length === 0) return [];
      const actualColumnCount = Math.min(length, columnCount);
      const chunks = Array.from({ length: actualColumnCount }, () => []);
      this.billingOverview.forEach((item, index) => {
        chunks[index % actualColumnCount].push(item);
      });
      return chunks;
    },
    responsiveGridClass() {
      const cols = this.columnCount;
      return {
        "grid-cols-1": cols === 1,
        "grid-cols-2": cols === 2,
        "grid-cols-3": cols === 3,
        "grid-cols-4": cols === 4,
      };
    },
    paymentLength() {
      return this.paymentList?.data?.length;
    },
    seriesData() {
      return [
        this.paymentOverview?.successCount ?? 0,
        this.paymentOverview?.failedCount ?? 0,
        this.paymentOverview?.disputeCount ?? 0,
      ];
    },
    minYM() {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, '0');
      return `${year}-${month}`;
    },
    failedReasons() {
      return this.billingOverview.map(item => ({
        text: item.title,
        value: item.title
      }));
    }
  },
  mounted() {
     this.$nextTick(() => {
      this.handleResize(); 
    });
    window.addEventListener("resize", this.handleResize);
    this.getData();
    this.getBillingPaymentOverview();
    this.getFailedTempDetailsMonthlyWise();
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
        this.windowWidth = window.innerWidth;
        this.$forceUpdate()
    },
    encodedId(id) {
      return btoa(id);
    },
    clearData() {
      this.filterQuery = { ...filterData };
      this.clear = !this.clear;
      this.getData(this.filterQuery);
      this.clearKey += 1;
      this.failedReasons = [...this.storedFailedReasons];
    },
    applyFilter() {
      if (this.locationAgentId) {
        this.getData(this.filterQuery, this.locationAgentId);
      } else {
        this.getData(this.filterQuery);
      }
    },
    async getData(filters = {}, agentId = null) {
      let url;
      let filtersCopy = { ...filters };

      if (Array.isArray(filtersCopy.reason) && filtersCopy.reason.length) {
        if (typeof filtersCopy.reason[0] === 'object' && filtersCopy.reason[0] !== null) {
          filtersCopy.reason = filtersCopy.reason.map(r => r.value).join(',');
        } else {
          filtersCopy.reason = filtersCopy.reason.join(',');
        }
      }

      if (agentId) {
        filtersCopy.agent_id = agentId;
      }

      const filterUrl = Helper.objToUrlParams(filtersCopy);
      url = `${this.$endpoint.GET_EXTRA_PAYMENT}?${filterUrl}`;

      this.isBillingLoading = true;
      await axios
        .get(url)
        .then(res => {
          this.paymentList = res.data;
          this.paymentList.current_page = res.data.current_page;
          this.paymentList.per_page = res.data.per_page;
          this.paymentList.total = res.data.total;
          this.filterQuery.exportPageSize = res.data.total;
        })
        .finally(() => {
          this.isBillingLoading = false;
        });
    },
    async exportMember() {
      let url;
      let filtersCopy = { ...this.filterQuery };
      if (Array.isArray(filtersCopy.reason) && filtersCopy.reason.length) {
        if (typeof filtersCopy.reason[0] === 'object' && filtersCopy.reason[0] !== null) {
          filtersCopy.reason = filtersCopy.reason.map(r => r.value).join(',');
        } else {
          filtersCopy.reason = filtersCopy.reason.join(',');
        }
      }
      let filterUrl = Helper.objToUrlParams(filtersCopy);
      url = `${this.$endpoint.GET_EXTRA_PAYMENT}/export?${filterUrl}`;

      let loader = this.$loading.show();
      await axios
        .get(url)
        .then(res => {
          window.open(res.data.data.file_url, "_blank");
        })
        .finally(() => {
          loader.hide();
        });
    },
    getBillingPaymentOverview(agentId = null) {
      let date = ((ym) => `${ym.slice(3)}-${ym.slice(0, 2)}`)(this.selectedYM);
      let url = `v2/get-billing-payment-overview?date=${date}`;
      if (agentId) {
        url += `&agent_id=${agentId}`;
      }

      let loader = this.$loading.show();
      Api.get(url)
        .then(({ data }) => {
          this.paymentOverview = data.data;
          this.billingOverview = data.data.failedCategory;
        })
        .catch(err => {
          console.error("Error: ", err.response.data.message);
        })
        .finally(() => {
          loader.hide();
        });
    },
    getFailedTempDetailsMonthlyWise(agentId = null) {
      let year = ((ym) => `${ym.slice(3)}`)(this.selectedYM);
      let url = `v2/get-failed-temp-details-monthly-wise?date=${year}`;
      if (agentId) {
        url += `&agent_id=${agentId}`;
      }

      let loader = this.$loading.show();
      Api.get(url)
        .then(({ data }) => {
          this.graphData = data.data;
        })
        .catch(err => {
          console.error("Error: ", err.response.data.message);
        })
        .finally(() => {
          loader.hide();
        });
    }
  },
  watch: {
    selectedLocation(newVal) {
      this.locationAgentId = newVal?.value || null;
      this.getData({},  this.locationAgentId);
      this.getBillingPaymentOverview(this.locationAgentId);
      this.getFailedTempDetailsMonthlyWise(this.locationAgentId);
    },
    selectedYM: {
      handler() {
        this.billingOverview = {};
        this.graphData = {};
        this.paymentOverview = {};
        this.getBillingPaymentOverview();
        this.getFailedTempDetailsMonthlyWise();
        this.clearData();
      }
    }
  }
};
</script>

<style src="../styles/billing.css"></style>
<style src="../../../assets/css/lead-listing.css"></style>
<style scoped>
.billingoverview_table,
.billingoverview_body {
  border-left: 1px solid #d7e1ea;
}

.billingoverview_table .billingoverview_header {
  font-weight: 600;
  background-color: #f3f7fa;
  border: 1px solid #d7e1ea;
  border-left: 0;
  color: #212529;
}

.billingoverview_table .billingoverview_header ul li .header-title,
.billingoverview_body li .titlevalue {
  border-right: 1px solid #d7e1ea;
  word-break: break-all;
}

.billingoverview_table .billingoverview_header ul li .header-value,
.billingoverview_body .countvalue {
  width:90px;
  flex-shrink: 0;
  word-break: break-all;
}

.billingoverview_list {
  border-right: 1px solid #d7e1ea;
  border-bottom: 1px solid #d7e1ea;
  border-top: 0;
  background-color: #fff;
}

.billingoverview_table .billingoverview_header ul,
.billingoverview_body {
  list-style: none;
}

.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}

.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.grid-cols-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.grid-cols-4 {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}
.billingoverview_table-sm{
  display: none;
}
.billingoverview_table-sm .br-0{
  border-radius: 0;
}
@media screen and (max-width: 576px) {
.billingoverview_table-lg{
  display: none;
}
.billingoverview_table-sm{
  display: block;
}
}
/* Skeleton loader */
.skeleton {
  background: linear-gradient(90deg, #e0e0e0 25%, #f5f5f5 37%, #e0e0e0 63%);
  background-size: 400% 100%;
  animation: skeleton-loading 1.4s ease infinite;
  border-radius: 4px;
  display: inline-block;
}

.skeleton-cell {
  width: 100%;
  height: 14px;
}

.skeleton-pill {
  width: 80px;
  height: 24px;
  border-radius: 50px;
}

.skeleton-action {
  width: 28px;
  height: 28px;
  border-radius: 50%;
}

.skeleton-row td {
  vertical-align: middle;
}

@keyframes skeleton-loading {
  0% { background-position: 100% 0; }
  100% { background-position: 0 0; }
}
</style>
